var _div;
var _excluded = ["className", "separator", "style", "text", "toolTipText"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useContext, useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { string, object, number, oneOfType, node } from 'prop-types';
import { styled } from '@mui/material/styles';
import { useWindowSize } from '../hooks';
import SovosTooltip from '../sovos-tooltip';
import { ResizeContext } from '../internals/utils';
var StyledSpan = styled('span')({
  display: 'inline-block',
  margin: 0,
  maxWidth: '100%',
  overflow: 'hidden',
  padding: 0,
  textOverflow: 'ellipsis',
  verticalAlign: 'middle',
  whiteSpace: 'nowrap'
});
export var shouldOverflowStateChange = function shouldOverflowStateChange(scrollWidth, width, prevState) {
  if (scrollWidth > width && !prevState) {
    return true;
  }
  if (scrollWidth <= width && prevState) {
    return true;
  }
  return false;
};
var getToolTipContent = function getToolTipContent(text, toolTipText, textDoesOverflow, separator) {
  if (textDoesOverflow && toolTipText) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, text, " ", separator, " ", toolTipText);
  }
  if (textDoesOverflow) {
    return text;
  }
  if (toolTipText) {
    return toolTipText;
  }
  return undefined;
};

/**
 * Fixed Width Text shows ellipsis & tooltip on non-wrapping text that
 * overflows it's container.
 */
var SovosFixedWidthText = function SovosFixedWidthText(_ref) {
  var className = _ref.className,
    separator = _ref.separator,
    style = _ref.style,
    text = _ref.text,
    toolTipText = _ref.toolTipText,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    textDoesOverflow = _useState2[0],
    setTextDoesOverflow = _useState2[1];
  var textRef = useRef(null);
  var _useWindowSize = useWindowSize(),
    windowWidth = _useWindowSize.width;
  var _useContext = useContext(ResizeContext),
    contextWidth = _useContext.width;
  useEffect(function () {
    if (text == null) return;
    var textScrollWidth = textRef.current.scrollWidth;
    var textWidth = textRef.current.offsetWidth;
    if (shouldOverflowStateChange(textScrollWidth, textWidth, textDoesOverflow)) {
      setTextDoesOverflow(function (prevState) {
        return !prevState;
      });
    }
  }, [textDoesOverflow, text, windowWidth, contextWidth]);
  if (text == null) return null;
  var toolTipContent = getToolTipContent(text, toolTipText, textDoesOverflow, separator);

  // The content element needs to have an empty, block display, child element to prevent Safari from showing
  // a native tooltip for the overflowing text.
  var content = /*#__PURE__*/React.createElement(StyledSpan, _extends({
    "aria-label": toolTipText,
    className: clsx('sovosFixedWidthText', className),
    style: style,
    ref: textRef,
    key: text
  }, rest), _div || (_div = /*#__PURE__*/React.createElement("div", null)), text);
  if (toolTipContent) {
    content = /*#__PURE__*/React.createElement(SovosTooltip, {
      title: toolTipContent
    }, content);
  }
  return content;
};
SovosFixedWidthText.propTypes = {
  /**
   * Extend the class name applied to the root element
   */
  className: string,
  /**
   * A custom separator between the `text` and `toolTipText` in the tooltip
   */
  separator: node,
  /**
   * Inline styles applied to the root element
   */
  style: object,
  /**
   * The text to be displayed and shown in a tooltip when truncated
   */
  text: oneOfType([string, number]),
  /**
   * Content to be displayed only in the tooltip, regardless of whether
   * `text` is truncated. When present, a tooltip will always be available
   */
  toolTipText: string
};
SovosFixedWidthText.defaultProps = {
  className: undefined,
  separator: '•',
  style: {},
  text: undefined,
  toolTipText: undefined
};
export default SovosFixedWidthText;